import React from 'react';
import { useSearchTab } from '../SearchTabContext';
// import SearchFlightPanel1 from '../FlightPanel/SearchFlightPanel1';
import HotelSearchPanel1 from '../HotelPanel/HotelSearchPanel1';


const TemplateHeroTabbedSearch = () => {
  const { activeTab } = useSearchTab();

  // Configuration for each tab's content
  const heroConfig = {
    home: {
      image: 'https://images.pexels.com/photos/2325446/pexels-photo-2325446.jpeg',
      title: 'Your Next Adventure Awaits',
      subtitle: 'Explore our curated packages to the world\'s most breathtaking destinations.',
    },
    flights: {
      image: 'https://images.pexels.com/photos/46148/aircraft-jet-landing-cloud-46148.jpeg',
      title: 'Search and Book Flights',
      subtitle: 'Find the best flight deals for your perfect trip.',
    },
    hotels: {
      image: 'https://images.pexels.com/photos/258154/pexels-photo-258154.jpeg',
      title: 'Find the Perfect Place to Stay',
      subtitle: 'Search our wide selection of hotels.',
    },
    packages: { // <-- NEW: Config for the packages tab
      image: 'https://images.pexels.com/photos/2325446/pexels-photo-2325446.jpeg',
      title: 'Discover Our Packages',
      subtitle: 'Hand-crafted itineraries for every type of traveler.',
    },
  };
  
  const currentConfig = heroConfig[activeTab] || heroConfig.home;

  // --- THIS IS THE NEW LOGIC FOR SHOWING THE SEARCH PANEL ---
  // The search panel should only be visible for 'flights' and 'hotels'.
  const showSearchPanel = ['flights', 'hotels'].includes(activeTab);

  // Define styles using CSS variables
  const styles = {
    heroContainer: {
      minHeight: '80vh',
      backgroundImage: `url('${currentConfig.image}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      transition: 'background-image 0.5s ease-in-out',
    },
    overlay: {
      backgroundColor: 'var(--hero-overlay-color, rgba(0,0,0,0.5))',
    },
    title: {
        fontFamily: 'var(--hero-title-font-family,#e9ecef "Arial, sans-serif")',
        color: 'var(--hero-subtitle-color, #e9ecef)',
    },
    subtitle: {
        color: 'var(--hero-subtitle-color, #e9ecef)',
    }
  };

  return (
    <section className="position-relative d-flex align-items-center" style={styles.heroContainer}>
      <div className="position-absolute w-100 h-100 top-0 start-0" style={styles.overlay}></div>
      
      <div className="container position-relative">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            
            {/* --- REVISED DYNAMIC CONTENT AREA --- */}

            {/* Title and Subtitle (Always visible) */}
            <div className="text-center text-white mb-4">
              <h1 className="display-4 fw-bold" style={styles.title}>{currentConfig.title}</h1>
              <p className="lead fs-4" style={styles.subtitle}>{currentConfig.subtitle}</p>
            </div>

            {/* Inspirational Buttons (Show for Home and Packages) */}
            {!showSearchPanel && (
                <div className="d-flex gap-3 justify-content-center">
                    <a href="#" className="btn btn-primary btn-lg rounded-pill px-5 py-3">Explore Now</a>
                </div>
            )}
            
            {/* Search Panel Container (Show for Flights and Hotels) */}
            {/* {showSearchPanel && (
              <div className="bg-white rounded shadow-lg p-4">
                {activeTab === 'flights' && <SearchFlightPanel1 />}
                {activeTab === 'hotels' && <HotelSearchPanel1 />}
              </div>
            )} */}

          </div>
        </div>
      </div>
    </section>
  );
};

export default TemplateHeroTabbedSearch;